import React from 'react';
import { LuPackage, LuRocket, LuTruck, LuArrowRight, LuCar } from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const services = [
  {
    icon: LuPackage,
    title: "Garuda Reguler (G-Reg)",
    text: "Solusi pengiriman ekonomis dengan estimasi waktu standar yang dapat diandalkan untuk kebutuhan logistik harian Anda.",
  },
  {
    icon: LuRocket,
    title: "Garuda Kilat (G-Kilat)",
    text: "Layanan pengiriman prioritas. Paket Anda dijamin sampai keesokan harinya (Next Day Delivery) untuk area jangkauan tertentu.",
  },
  {
    icon: LuTruck,
    title: "Garuda Kargo Darat & Udara",
    text: "Pengiriman barang dalam jumlah besar (bulk) atau alat berat dengan tarif yang lebih efisien dan armada yang tangguh.",
  },
  {
    icon: LuCar,
    title: "Garuda Towing",
    text: "Layanan derek darurat dan pengiriman kendaraan 24 jam. Kami siap mengevakuasi mobil mogok atau pengiriman antar kota dengan aman dan profesional.",
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

export default function Services({ onBook }) {
  return (
    <section id="layanan" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-3xl md:text-4xl font-bold text-navy mb-4"
          >
            Layanan Kami
          </motion.h2>
          <motion.div 
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="w-20 h-1.5 bg-orange mx-auto rounded-full mb-6"
          ></motion.div>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-gray-600 text-lg"
          >
            Pilih layanan yang paling sesuai dengan kebutuhan Anda. Kami menyediakan berbagai opsi untuk memastikan fleksibilitas dan efisiensi.
          </motion.p>
        </div>

        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid md:grid-cols-2 gap-8"
        >
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              variants={itemVariants}
              className="group p-8 rounded-3xl bg-white border border-gray-100 hover:border-orange/20 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full"
            >
              <div className="w-16 h-16 rounded-2xl bg-navy/5 flex items-center justify-center text-orange mb-6 group-hover:bg-orange group-hover:text-white transition-all duration-300 shadow-inner">
                <SafeIcon icon={service.icon} className="w-8 h-8" />
              </div>
              <h3 className="font-heading text-2xl font-bold text-navy mb-3">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-8 flex-grow">
                {service.text}
              </p>
              
              {/* CTA Button per layanan */}
              <button 
                onClick={() => onBook(service.title)}
                className="font-heading mt-auto w-full inline-flex items-center justify-center gap-2 py-3 px-4 bg-gray-50 hover:bg-orange text-navy hover:text-white font-semibold rounded-xl transition-colors duration-300 group-hover:shadow-md"
              >
                Pilih Layanan Ini
                <SafeIcon icon={LuArrowRight} className="w-4 h-4" />
              </button>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}